export const PAGINATION_PAGE_SIZE = 10

export const PAGINGATION_DEFAULT: TPagination.ReceiveFromServer = {
  pageIndex: 1,
  pageSize: PAGINATION_PAGE_SIZE,
  totalRecords: 0,
  totalPage: 0,
  hasNextPage: false,
  hasPreviousPage: false
}

export const QUERY_PAGING = {
  PageIndex: 1,
  PageSize: PAGINATION_PAGE_SIZE
}
